import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useConversationWidgetContext } from '../../../../components/ConversationWidget'

export const AddNewConversationButton = () => {
  const { openConversationWidget } = useConversationWidgetContext()

  const onClick = () => {
    openConversationWidget()
  }
  return <BusyButton onClick={onClick}>Add new message</BusyButton>
}
